export const ProductStatus = [
    { value: 1, label: "Organic" },
    { value: 2, label: "Conventional" },
    { value: 3, label: "Halal" },
    { value: 4, label: "Kosher" },
    { value: 5, label: "Vegan" },
];
